module.exports = __webpack_public_path__ + "img/drugs_coronary_heart_disease.4e6bb89d.png";